module.exports = __webpack_public_path__ + "static/media/square.37d06fbc.svg";